import { jwtDecode } from "jwt-decode";

import cookie from "./cookie.js";

const isDevelopmentEnvironment = () => {
	if (typeof window === "undefined" || !window.location) return false;
	const hostname = window.location.hostname.toLowerCase();
	return hostname.includes("localhost") || hostname.includes("development");
};

const getCookieOptions = () => {
	if (isDevelopmentEnvironment()) return { path: "/" };
	return { domain: ".issel.ee.auth.gr", path: "/" };
};

const jwt = {
	getToken: () => cookie.get("_leaderboard"),
	setToken: (token) => {
		if (token) {
			const options = getCookieOptions();
			cookie.set("_leaderboard", token, options);
		}
	},
	destroyToken: () => {
		try {
			cookie.remove("_leaderboard");
		} catch { /* empty */ }

		const options = getCookieOptions();
		cookie.remove("_leaderboard", options);
	},
	isAuthenticated: () => {
		const token = cookie.get("_leaderboard");
		return token && token !== "undefined";
	},
	isAdmin: () => {
		const token = cookie.get("_leaderboard");
		if (token) {
			const decoded = jwtDecode(token);
			return decoded && decoded.role === "admin";
		}

		return false;
	},
	decode: () => {
		const token = cookie.get("_leaderboard");
		if (token) return jwtDecode(token);
		cookie.remove("_leaderboard");
		window.location.href = "/";
		return null;
	},
};

export default jwt;
